import React, { useState } from "react";
import { Row, Col, Image, Button, Empty } from "antd";
import { LeftOutlined, RightOutlined, EyeOutlined } from "@ant-design/icons";

const CustomCarouselGroup = ({
  imgList = [],
  itemsPerSlide = 2, 
  setShowModalImage
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const currentImages = imgList.slice(currentIndex, currentIndex + itemsPerSlide);

  const prevImages = () => {
    setCurrentIndex((prev) => Math.max(prev - itemsPerSlide, 0));
  };

  const nextImages = () => {
    setCurrentIndex((prev) =>
      Math.min(prev + itemsPerSlide, imgList.length - itemsPerSlide)
    );
  };

  if (imgList.length === 0) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }

  return (
    <Row justify="center" align="middle" gutter={16}>
      {imgList.length > itemsPerSlide && (
        <Button
          type="text"
          icon={<LeftOutlined />}
          onClick={prevImages}
          disabled={currentIndex === 0}
        />
      )}

      <Row gutter={16} justify="center" className="carousel-container">
        {currentImages.map((url, index) => (
          <Col key={index} className="carousel-image-wrapper">
            <div className="image-container">
              <Image
                src={url}
                alt={`image-${index}`}
                className="carousel-image"
                preview={{
                  mask: <EyeOutlined style={{ fontSize: 24 }} />,
                  onVisibleChange: (visible) => {
                    setShowModalImage(!visible);
                  },
                  zIndex:2000
                }}
              />
            </div>
          </Col>
        ))}
      </Row>

      {imgList.length > itemsPerSlide && (
        <Button
          type="text"
          icon={<RightOutlined />}
          onClick={nextImages}
          disabled={currentIndex + itemsPerSlide >= imgList.length}
        />
      )}
    </Row>
  );
};

export default CustomCarouselGroup;
